/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleGetResponseModel } from '../../models/article-get-response-model';

export interface ArticlePublisherIdIdGet$Plain$Params {
  publisherId: string;
  id: string;
}

export function articlePublisherIdIdGet$Plain(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleGetResponseModel>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<ArticleGetResponseModel>;
    })
  );
}

articlePublisherIdIdGet$Plain.PATH = '/Article/{publisherId}/{id}';
